const Row = (props: any) => {
    const className = "row" + (!!props?.className ? ` ${props.className}` : "");
    return <div className={className}>{props.children}</div>
}

export default Row;